import script from "./MultiSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSection.vue?vue&type=script&setup=true&lang=js"

import "./MultiSection.vue?vue&type=style&index=0&id=7e9e06aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9e06aa"]])

export default __exports__